const NewWorldRegionModel = {
  NORTH_AMERICA: {
    id: 1,
    title: 'North America',
  },

  CENTRAL_EUROPE: {
    id: 2,
    title: 'Central Europe',
  },

  SOUTH_AMERICA: {
    id: 3,
    title: 'South America',
  },

  AUSTRALIA: {
    id: 4,
    title: 'Australia',
  },
};

NewWorldRegionModel.LIST = [
  NewWorldRegionModel.AUSTRALIA,
  NewWorldRegionModel.CENTRAL_EUROPE,
  NewWorldRegionModel.NORTH_AMERICA,
  NewWorldRegionModel.SOUTH_AMERICA,
];

NewWorldRegionModel.ID_TO_DATA = {
  [NewWorldRegionModel.AUSTRALIA.id]: NewWorldRegionModel.AUSTRALIA,
  [NewWorldRegionModel.CENTRAL_EUROPE.id]: NewWorldRegionModel.CENTRAL_EUROPE,
  [NewWorldRegionModel.NORTH_AMERICA.id]: NewWorldRegionModel.NORTH_AMERICA,
  [NewWorldRegionModel.SOUTH_AMERICA.id]: NewWorldRegionModel.SOUTH_AMERICA,
};

const NewWorldServerModel = {
  // Не забудь обновить бэк.
  // @see \App\Types\Maps\ServerMap -> ProductGameEnum::GAME_NW -> ServerMap::NW_REGION_AUSTRALIA
  [NewWorldRegionModel.AUSTRALIA.id]: [
    {
      id: 1,
      title: 'Acherusia - AP Southeast',
    },
    {
      id: 2,
      title: 'Adiri - AP Southeast',
    },
    {
      id: 3,
      title: 'Agartha - AP Southeast',
    },
    {
      id: 4,
      title: 'Alakapuri - AP Southeast',
    },
    {
      id: 5,
      title: 'Baralku - AP Southeast',
    },
    {
      id: 6,
      title: 'Barzakh - AP Southeast',
    },
    {
      id: 7,
      title: 'Batala - AP Southeast',
    },
    {
      id: 8,
      title: 'Buzhou - AP Southeast',
    },
    {
      id: 9,
      title: 'Cretea - AP Southeast',
    },
    {
      id: 10,
      title: 'Crommyon - AP Southeast',
    },
    {
      id: 43,
      title: 'Crux - AP Southeast',
    },
    {
      id: 11,
      title: 'Cynthus - AP Southeast',
    },
    {
      id: 12,
      title: 'Delos - AP Southeast',
    },
    {
      id: 13,
      title: 'Duzakh - AP Southeast',
    },
    {
      id: 14,
      title: 'Eridu - AP Southeast',
    },
    {
      id: 15,
      title: 'Erythia - AP Southeast',
    },
    {
      id: 16,
      title: 'Fusang - AP Southeast',
    },
    {
      id: 17,
      title: 'Geatland - AP Southeast',
    },
    {
      id: 18,
      title: 'Hawaiki - AP Southeast',
    },
    {
      id: 19,
      title: 'Heorot - AP Southeast',
    },
    {
      id: 20,
      title: 'Hsuan - AP Southeast',
    },
    {
      id: 21,
      title: 'Ibabawnon - AP Southeast',
    },
    {
      id: 22,
      title: 'Kabatakan - AP Southeast',
    },
    {
      id: 23,
      title: 'Khmun - AP Southeast',
    },
    {
      id: 24,
      title: 'Kibu - AP Southeast',
    },
    {
      id: 25,
      title: 'Kressa - AP Southeast',
    },
    {
      id: 26,
      title: 'Kyphanta - AP Southeast',
    },
    {
      id: 27,
      title: 'Lagado - AP Southeast',
    },
    {
      id: 28,
      title: 'Laputa - AP Southeast',
    },
    {
      id: 29,
      title: 'Lemuria - AP Southeast',
    },
    {
      id: 30,
      title: 'Lerna - AP Southeast',
    },
    {
      id: 31,
      title: 'Lindalino - AP Southeast',
    },
    {
      id: 32,
      title: 'Luggnagg - AP Southeast',
    },
    {
      id: 33,
      title: 'Myrkalfar - AP Southeast',
    },
    {
      id: 41,
      title: 'Pisces - AP Southeast',
    },
    {
      id: 34,
      title: 'Puyok - AP Southeast',
    },
    {
      id: 35,
      title: 'Ryugu-Jo - AP Southeast',
    },
    {
      id: 44,
      title: 'Sutekh - AP Southeast',
    },
    {
      id: 42,
      title: 'Taiyi - AP Southeast',
    },
    {
      id: 36,
      title: 'Utopia - AP Southeast',
    },
    {
      id: 37,
      title: 'Yama - AP Southeast',
    },
    {
      id: 38,
      title: 'Yomi - AP Southeast',
    },
    {
      id: 39,
      title: 'Yulbrada - AP Southeast',
    },
    {
      id: 40,
      title: 'Zara - AP Southeast',
    },
  ],
  // Не забудь обновить бэк.
  // @see \App\Types\Maps\ServerMap -> ProductGameEnum::GAME_NW -> ServerMap::NW_REGION_CENTRAL_EUROPE
  [NewWorldRegionModel.CENTRAL_EUROPE.id]: [
    {
      id: 1,
      title: 'Aaru - EU Central',
    },
    {
      id: 2,
      title: 'Abaton - EU Central',
    },
    {
      id: 3,
      title: 'Acamar - EU Central',
    },
    {
      id: 4,
      title: 'Acrux - EU Central',
    },
    {
      id: 5,
      title: 'Aepyornis - EU Central',
    },
    {
      id: 6,
      title: 'Aiolio - EU Central',
    },
    {
      id: 7,
      title: 'Alastor - EU Central',
    },
    {
      id: 8,
      title: 'Albraca (DE/EN) - EU Central',
    },
    {
      id: 9,
      title: 'Alfheim - EU Central',
    },
    {
      id: 10,
      title: 'Alioth - EU Central',
    },
    {
      id: 11,
      title: 'Altruria - EU Central',
    },
    {
      id: 12,
      title: 'Amenti - EU Central',
    },
    {
      id: 208,
      title: 'Andrometus - EU Central',
    },
    {
      id: 13,
      title: 'Annwyn - EU Central',
    },
    {
      id: 14,
      title: 'Antares - EU Central',
    },
    {
      id: 15,
      title: 'Antillia - EU Central',
    },
    {
      id: 16,
      title: 'Apis - EU Central',
    },
    {
      id: 206,
      title: 'Apus - EU Central',
    },
    {
      id: 17,
      title: 'Aquila - EU Central',
    },
    {
      id: 18,
      title: 'Arcturus - EU Central',
    },
    {
      id: 19,
      title: 'Argyre - EU Central',
    },
    {
      id: 205,
      title: 'Aries - EU Central',
    },
    {
      id: 20,
      title: 'Asgard - EU Central',
    },
    {
      id: 207,
      title: 'Asterion - EU Central',
    },
    {
      id: 21,
      title: 'Avalon - EU Central',
    },
    {
      id: 22,
      title: 'Bakhu - EU Central',
    },
    {
      id: 23,
      title: 'Balanjar - EU Central',
    },
    {
      id: 24,
      title: 'Baltia - EU Central',
    },
    {
      id: 25,
      title: 'Baltica - EU Central',
    },
    {
      id: 26,
      title: 'Banoic - EU Central',
    },
    {
      id: 27,
      title: 'Barri - EU Central',
    },
    {
      id: 28,
      title: 'Barsoom - EU Central',
    },
    {
      id: 29,
      title: 'Bengodi (ES/EN) - EU Central',
    },
    {
      id: 30,
      title: 'Bensalem - EU Central',
    },
    {
      id: 31,
      title: 'Bermeja - EU Central',
    },
    {
      id: 32,
      title: 'Betelgeuse - EU Central',
    },
    {
      id: 33,
      title: 'Bifrost - EU Central',
    },
    {
      id: 34,
      title: 'Bran - EU Central',
    },
    {
      id: 35,
      title: 'Brittia - EU Central',
    },
    {
      id: 36,
      title: 'Caelum - EU Central',
    },
    {
      id: 37,
      title: 'Caer Sidi - EU Central',
    },
    {
      id: 38,
      title: 'Canis - EU Central',
    },
    {
      id: 39,
      title: 'Canopis - EU Central',
    },
    {
      id: 40,
      title: 'Caph - EU Central',
    },
    {
      id: 41,
      title: 'Caprona - EU Central',
    },
    {
      id: 42,
      title: 'Carcosa - EU Central',
    },
    {
      id: 43,
      title: 'Caspak - EU Central',
    },
    {
      id: 44,
      title: 'Cassipa - EU Central',
    },
    {
      id: 211,
      title: 'Centaurus - EU Central',
    },
    {
      id: 45,
      title: 'Charadra - EU Central',
    },
    {
      id: 46,
      title: 'Chryse - EU Central',
    },
    {
      id: 47,
      title: 'Corbenic - EU Central',
    },
    {
      id: 48,
      title: 'Cygnus - EU Central',
    },
    {
      id: 49,
      title: 'Damalis - EU Central',
    },
    {
      id: 50,
      title: 'Delphnius - EU Central',
    },
    {
      id: 51,
      title: 'Diana`s Grove - EU Central',
    },
    {
      id: 204,
      title: 'Draco - EU Central',
    },
    {
      id: 52,
      title: 'Dry Tree - EU Central',
    },
    {
      id: 53,
      title: 'Duat - EU Central',
    },
    {
      id: 54,
      title: 'Dvaraka - EU Central',
    },
    {
      id: 55,
      title: 'Ekera - EU Central',
    },
    {
      id: 56,
      title: 'Emathia - EU Central',
    },
    {
      id: 57,
      title: 'Erewhon - EU Central',
    },
    {
      id: 58,
      title: 'Eridanus - EU Central',
    },
    {
      id: 59,
      title: 'Eridanus Luft - EU Central',
    },
    {
      id: 60,
      title: 'Estotiland - EU Central',
    },
    {
      id: 61,
      title: 'Eurytheia - EU Central',
    },
    {
      id: 62,
      title: 'Evonium - EU Central',
    },
    {
      id: 63,
      title: 'Fae - EU Central',
    },
    {
      id: 64,
      title: 'Finias - EU Central',
    },
    {
      id: 65,
      title: 'Fomax - EU Central',
    },
    {
      id: 66,
      title: 'Frisland - EU Central',
    },
    {
      id: 67,
      title: 'Ganzir (DE/EN) - EU Central',
    },
    {
      id: 68,
      title: 'Gaunes - EU Central',
    },
    {
      id: 69,
      title: 'Gladsheim - EU Central',
    },
    {
      id: 70,
      title: 'Glitnir - EU Central',
    },
    {
      id: 71,
      title: 'Glyn Cagny - EU Central',
    },
    {
      id: 72,
      title: 'Goldenthal - EU Central',
    },
    {
      id: 73,
      title: 'Gorias - EU Central',
    },
    {
      id: 74,
      title: 'Groclant - EU Central',
    },
    {
      id: 75,
      title: 'Grus - EU Central',
    },
    {
      id: 76,
      title: 'Hades - EU Central',
    },
    {
      id: 77,
      title: 'Harmonia - EU Central',
    },
    {
      id: 78,
      title: 'Harpinna - EU Central',
    },
    {
      id: 79,
      title: 'Hellheim - EU Central',
    },
    {
      id: 80,
      title: 'Hellopia - EU Central',
    },
    {
      id: 81,
      title: 'Heracleion - EU Central',
    },
    {
      id: 82,
      title: 'Hippotae - EU Central',
    },
    {
      id: 83,
      title: 'Hydrus - EU Central',
    },
    {
      id: 84,
      title: 'Hyperborea - EU Central',
    },
    {
      id: 85,
      title: 'Icaria - EU Central',
    },
    {
      id: 86,
      title: 'Idavoll - EU Central',
    },
    {
      id: 87,
      title: 'Ife - EU Central',
    },
    {
      id: 88,
      title: 'Inferni - EU Central',
    },
    {
      id: 89,
      title: 'Iroko - EU Central',
    },
    {
      id: 90,
      title: 'Ishtakar - EU Central',
    },
    {
      id: 91,
      title: 'Ismarus Eta - EU Central',
    },
    {
      id: 92,
      title: 'Ismarus Theta - EU Central',
    },
    {
      id: 93,
      title: 'Izar - EU Central',
    },
    {
      id: 94,
      title: 'Jacquet - EU Central',
    },
    {
      id: 95,
      title: 'Jansenia - EU Central',
    },
    {
      id: 96,
      title: 'Jotunheim (IT/EN) - EU Central',
    },
    {
      id: 97,
      title: 'Jumala - EU Central',
    },
    {
      id: 98,
      title: 'Kalevala - EU Central',
    },
    {
      id: 99,
      title: 'Kaloon - EU Central',
    },
    {
      id: 100,
      title: 'Kantia - EU Central',
    },
    {
      id: 101,
      title: 'Karaka - EU Central',
    },
    {
      id: 102,
      title: 'Karkar - EU Central',
    },
    {
      id: 103,
      title: 'Kerguelen - EU Central',
    },
    {
      id: 104,
      title: 'Ketumati - EU Central',
    },
    {
      id: 105,
      title: 'Kianida - EU Central',
    },
    {
      id: 106,
      title: 'Kioram - EU Central',
    },
    {
      id: 107,
      title: 'Kor (ES/EN) - EU Central',
    },
    {
      id: 214,
      title: 'Kronos - EU Central',
    },
    {
      id: 108,
      title: 'Kurhah - EU Central',
    },
    {
      id: 109,
      title: 'Kvenland - EU Central',
    },
    {
      id: 110,
      title: 'Lacerta - EU Central',
    },
    {
      id: 111,
      title: 'Lamian - EU Central',
    },
    {
      id: 112,
      title: 'Larissa - EU Central',
    },
    {
      id: 113,
      title: 'Learad - EU Central',
    },
    {
      id: 114,
      title: 'Lepus - EU Central',
    },
    {
      id: 115,
      title: 'Lesath - EU Central',
    },
    {
      id: 116,
      title: 'Lethe - EU Central',
    },
    {
      id: 117,
      title: 'Lyonesse (PL/EN) - EU Central',
    },
    {
      id: 118,
      title: 'Malva - EU Central',
    },
    {
      id: 119,
      title: 'Mandara - EU Central',
    },
    {
      id: 120,
      title: 'Mardi - EU Central',
    },
    {
      id: 121,
      title: 'Marsic - EU Central',
    },
    {
      id: 122,
      title: 'Mayda - EU Central',
    },
    {
      id: 123,
      title: 'Melinde - EU Central',
    },
    {
      id: 124,
      title: 'Menkar - EU Central',
    },
    {
      id: 125,
      title: 'Metsola - EU Central',
    },
    {
      id: 126,
      title: 'Midgard - EU Central',
    },
    {
      id: 127,
      title: 'Montes Serrorum - EU Central',
    },
    {
      id: 128,
      title: 'Murias - EU Central',
    },
    {
      id: 129,
      title: 'Muspelheim - EU Central',
    },
    {
      id: 130,
      title: 'Muziris - EU Central',
    },
    {
      id: 131,
      title: 'Nastrond - EU Central',
    },
    {
      id: 132,
      title: 'Nav - EU Central',
    },
    {
      id: 133,
      title: 'Naxos - EU Central',
    },
    {
      id: 134,
      title: 'Nembus - EU Central',
    },
    {
      id: 135,
      title: 'Nericus - EU Central',
    },
    {
      id: 136,
      title: 'Nexdorea - EU Central',
    },
    {
      id: 137,
      title: 'Niflheim - EU Central',
    },
    {
      id: 138,
      title: 'Noatun - EU Central',
    },
    {
      id: 139,
      title: 'Nowhere - EU Central',
    },
    {
      id: 140,
      title: 'Nysa - EU Central',
    },
    {
      id: 141,
      title: 'Nysos - EU Central',
    },
    {
      id: 142,
      title: 'Opar - EU Central',
    },
    {
      id: 143,
      title: 'Ophir - EU Central',
    },
    {
      id: 144,
      title: 'Otuken - EU Central',
    },
    {
      id: 145,
      title: 'Panchaia - EU Central',
    },
    {
      id: 146,
      title: 'Pavlopetri - EU Central',
    },
    {
      id: 147,
      title: 'Pellucidar - EU Central',
    },
    {
      id: 148,
      title: 'Penglai - EU Central',
    },
    {
      id: 149,
      title: 'Pepys - EU Central',
    },
    {
      id: 150,
      title: 'Perseus - EU Central',
    },
    {
      id: 151,
      title: 'Petermannland - EU Central',
    },
    {
      id: 152,
      title: 'Phaeacia - EU Central',
    },
    {
      id: 209,
      title: 'Phoenix - EU Central',
    },
    {
      id: 153,
      title: 'Pointland - EU Central',
    },
    {
      id: 154,
      title: 'Pollux - EU Central',
    },
    {
      id: 155,
      title: 'Pulotu - EU Central',
    },
    {
      id: 156,
      title: 'Pyrandia - EU Central',
    },
    {
      id: 157,
      title: 'Quivira - EU Central',
    },
    {
      id: 158,
      title: 'Ramaja - EU Central',
    },
    {
      id: 159,
      title: 'Ravenal - EU Central',
    },
    {
      id: 160,
      title: 'Ravenspurn - EU Central',
    },
    {
      id: 161,
      title: 'Rocabarra - EU Central',
    },
    {
      id: 162,
      title: 'Runeberg - EU Central',
    },
    {
      id: 163,
      title: 'Saba - EU Central',
    },
    {
      id: 164,
      title: 'Saena - EU Central',
    },
    {
      id: 210,
      title: 'Sagitta - EU Central',
    },
    {
      id: 165,
      title: 'Sanor - EU Central',
    },
    {
      id: 166,
      title: 'Serpens - EU Central',
    },
    {
      id: 167,
      title: 'Ship-Trap - EU Central',
    },
    {
      id: 168,
      title: 'Silpium (DE/EN) - EU Central',
    },
    {
      id: 212,
      title: 'Siren - EU Central',
    },
    {
      id: 169,
      title: 'Slavna - EU Central',
    },
    {
      id: 170,
      title: 'Styx - EU Central',
    },
    {
      id: 171,
      title: 'Suddene - EU Central',
    },
    {
      id: 172,
      title: 'Surba - EU Central',
    },
    {
      id: 173,
      title: 'Swevenham - EU Central',
    },
    {
      id: 174,
      title: 'Tabor Island - EU Central',
    },
    {
      id: 175,
      title: 'Takshasila - EU Central',
    },
    {
      id: 176,
      title: 'Tanje - EU Central',
    },
    {
      id: 177,
      title: 'Tartarus - EU Central',
    },
    {
      id: 213,
      title: 'Taurus - EU Central',
    },
    {
      id: 178,
      title: 'Thrudheim - EU Central',
    },
    {
      id: 179,
      title: 'Thule - EU Central',
    },
    {
      id: 180,
      title: 'Tir Na Nog - EU Central',
    },
    {
      id: 181,
      title: 'Tupia - EU Central',
    },
    {
      id: 182,
      title: 'Una-bara - EU Central',
    },
    {
      id: 183,
      title: 'Urdarbrunn - EU Central',
    },
    {
      id: 184,
      title: 'Ursa - EU Central',
    },
    {
      id: 185,
      title: 'Utgard (DE/EN) - EU Central',
    },
    {
      id: 186,
      title: 'Vagon - EU Central',
    },
    {
      id: 187,
      title: 'Vaikuntha - EU Central',
    },
    {
      id: 188,
      title: 'Vainola - EU Central',
    },
    {
      id: 189,
      title: 'Vega - EU Central',
    },
    {
      id: 190,
      title: 'Vicina - EU Central',
    },
    {
      id: 191,
      title: 'Vimur - EU Central',
    },
    {
      id: 192,
      title: 'Vineta - EU Central',
    },
    {
      id: 193,
      title: 'Vyrij - EU Central',
    },
    {
      id: 194,
      title: 'Wachusett - EU Central',
    },
    {
      id: 195,
      title: 'Wonderland - EU Central',
    },
    {
      id: 196,
      title: 'Wood Perilous - EU Central',
    },
    {
      id: 197,
      title: 'Xarayes - EU Central',
    },
    {
      id: 198,
      title: 'Yinjian - EU Central',
    },
    {
      id: 199,
      title: 'Youdu - EU Central',
    },
    {
      id: 200,
      title: 'Yourang - EU Central',
    },
    {
      id: 201,
      title: 'Zanara - EU Central',
    },
    {
      id: 202,
      title: 'Zerzura - EU Central',
    },
    {
      id: 203,
      title: 'Zu-Vendis - EU Central',
    },
  ],
  // Не забудь обновить бэк.
  // @see \App\Types\Maps\ServerMap -> ProductGameEnum::GAME_NW -> ServerMap::NW_REGION_NORTH_AMERICA
  [NewWorldRegionModel.NORTH_AMERICA.id]: [
    {
      id: 1,
      title: 'Aarnivalkea - US East',
    },
    {
      id: 2,
      title: 'Adlivun - US East',
    },
    {
      id: 3,
      title: 'Aeaea - US East',
    },
    {
      id: 4,
      title: 'Amano Iwato - US East',
    },
    {
      id: 5,
      title: 'Amsvartnir - US East',
    },
    {
      id: 6,
      title: 'Andlang - US East',
    },
    {
      id: 7,
      title: 'Antullia - US East',
    },
    {
      id: 218,
      title: 'Aquarius - US West',
    },
    {
      id: 211,
      title: 'Arctica - US East',
    },
    {
      id: 8,
      title: 'Argadnel - US East',
    },
    {
      id: 159,
      title: 'Ashok Vatika - US West',
    },
    {
      id: 9,
      title: 'Asmaida - US East',
    },
    {
      id: 10,
      title: 'Asphodel - US East',
    },
    {
      id: 11,
      title: 'Atvatabar - US East',
    },
    {
      id: 160,
      title: 'Aukumea - US West',
    },
    {
      id: 12,
      title: 'Aztlan - US East',
    },
    {
      id: 13,
      title: 'Babilary - US East',
    },
    {
      id: 14,
      title: 'Balnibarbi - US East',
    },
    {
      id: 15,
      title: 'Barataria - US East',
    },
    {
      id: 219,
      title: 'Bellatrix - US West',
    },
    {
      id: 16,
      title: 'Belovodye - US East',
    },
    {
      id: 17,
      title: 'Bembina - US East',
    },
    {
      id: 18,
      title: 'Bentusle - US East',
    },
    {
      id: 19,
      title: 'Bilskirnir - US East',
    },
    {
      id: 20,
      title: 'Blefuscu - US East',
    },
    {
      id: 21,
      title: 'Boosaule - US East',
    },
    {
      id: 22,
      title: 'Bouneima - US East',
    },
    {
      id: 23,
      title: 'Brazir - US East',
    },
    {
      id: 24,
      title: 'Briedablik - US East',
    },
    {
      id: 25,
      title: 'Britannula - US East',
    },
    {
      id: 26,
      title: 'Brobdingnag - US East',
    },
    {
      id: 27,
      title: 'Caeno - US East',
    },
    {
      id: 28,
      title: 'Caerleon - US East',
    },
    {
      id: 29,
      title: 'Calnogor - US East',
    },
    {
      id: 161,
      title: 'Camelot - US West',
    },
    {
      id: 30,
      title: 'Cantahar - US East',
    },
    {
      id: 31,
      title: 'Cantref Gwaelod - US East',
    },
    {
      id: 32,
      title: 'Carabas - US East',
    },
    {
      id: 33,
      title: 'Castle of Steel - US East',
    },
    {
      id: 212,
      title: 'Cathaysia - US East',
    },
    {
      id: 34,
      title: 'Cedar Forest - US East',
    },
    {
      id: 162,
      title: 'Celadon - US West',
    },
    {
      id: 35,
      title: 'Cenculiana - US East',
    },
    {
      id: 36,
      title: 'Ceryneia - US East',
    },
    {
      id: 37,
      title: 'Charybdis - US East',
    },
    {
      id: 38,
      title: 'Chicomoztoc - US East',
    },
    {
      id: 39,
      title: 'Chinvat - US East',
    },
    {
      id: 40,
      title: 'Cibola - US East',
    },
    {
      id: 213,
      title: 'Cimmeria - US East',
    },
    {
      id: 41,
      title: 'City of Brass - US East',
    },
    {
      id: 42,
      title: 'Deipnias - US East',
    },
    {
      id: 43,
      title: 'Difu - US East',
    },
    {
      id: 44,
      title: 'Dinas Emrys - US East',
    },
    {
      id: 45,
      title: 'Dindymon - US East',
    },
    {
      id: 163,
      title: 'Diranda - US West',
    },
    {
      id: 46,
      title: 'Dis - US East',
    },
    {
      id: 47,
      title: 'Diyu - US East',
    },
    {
      id: 48,
      title: 'Dominora - US East',
    },
    {
      id: 49,
      title: 'Duguang - US East',
    },
    {
      id: 50,
      title: 'Eden - US East',
    },
    {
      id: 164,
      title: 'El Dorado - US West',
    },
    {
      id: 220,
      title: 'El Nath - US West',
    },
    {
      id: 51,
      title: 'Elaea - US East',
    },
    {
      id: 52,
      title: 'Elelin - US East',
    },
    {
      id: 53,
      title: 'Elphame - US East',
    },
    {
      id: 54,
      title: 'Emain Albach - US East',
    },
    {
      id: 55,
      title: 'Empi - US East',
    },
    {
      id: 56,
      title: 'Ensipe - US East',
    },
    {
      id: 57,
      title: 'Eupana - US East',
    },
    {
      id: 58,
      title: 'Euphrates - US East',
    },
    {
      id: 59,
      title: 'Falias - US East',
    },
    {
      id: 165,
      title: 'Ferri - US West',
    },
    {
      id: 60,
      title: 'Folkvangr - US East',
    },
    {
      id: 61,
      title: 'Frislandia - US East',
    },
    {
      id: 62,
      title: 'Galunlati - US East',
    },
    {
      id: 63,
      title: 'Glubbdubdrib - US East',
    },
    {
      id: 64,
      title: 'Hanan Pacha - US East',
    },
    {
      id: 65,
      title: 'Harpagion - US East',
    },
    {
      id: 66,
      title: 'Heliopolis - US East',
    },
    {
      id: 67,
      title: 'Himavanta - US East',
    },
    {
      id: 68,
      title: 'Himinbjorg - US East',
    },
    {
      id: 69,
      title: 'Hippocrene - US East',
    },
    {
      id: 70,
      title: 'Houssa - US East',
    },
    {
      id: 214,
      title: 'Hudsonland - US East',
    },
    {
      id: 71,
      title: 'Hufaidh - US East',
    },
    {
      id: 72,
      title: 'Huokang - US East',
    },
    {
      id: 73,
      title: 'Hy-Brasil - US East',
    },
    {
      id: 166,
      title: 'Iardanes - US West',
    },
    {
      id: 74,
      title: 'Idadalmunon - US East',
    },
    {
      id: 75,
      title: 'Iriy - US East',
    },
    {
      id: 76,
      title: 'Irminsul - US East',
    },
    {
      id: 222,
      title: 'Isabella - US West',
    },
    {
      id: 77,
      title: 'Jezirat al Tennyn - US East',
    },
    {
      id: 78,
      title: 'Jiuquan - US East',
    },
    {
      id: 79,
      title: 'Jiuyou - US East',
    },
    {
      id: 80,
      title: 'Jiuyuan - US East',
    },
    {
      id: 215,
      title: 'Kalahari - US East',
    },
    {
      id: 81,
      title: 'Kaluwalhatian - US East',
    },
    {
      id: 82,
      title: 'Karpathenburg - US East',
    },
    {
      id: 83,
      title: 'Kay Pacha - US East',
    },
    {
      id: 210,
      title: 'Kenorland - US East',
    },
    {
      id: 84,
      title: 'Ker-Is - US East',
    },
    {
      id: 167,
      title: 'Killaraus - US West',
    },
    {
      id: 168,
      title: 'Kokytos - US West',
    },
    {
      id: 85,
      title: 'Krocylea - US East',
    },
    {
      id: 169,
      title: 'Kronomo - US West',
    },
    {
      id: 170,
      title: 'Kshira Sagara - US West',
    },
    {
      id: 86,
      title: 'Lemosyne - US East',
    },
    {
      id: 87,
      title: 'Lesnik - US East',
    },
    {
      id: 171,
      title: 'Lilliput - US West',
    },
    {
      id: 223,
      title: 'Lilith - US East',
    },
    {
      id: 88,
      title: 'Lin Lin - US East',
    },
    {
      id: 172,
      title: 'Linnunrata - US West',
    },
    {
      id: 173,
      title: 'Lintukoto - US West',
    },
    {
      id: 89,
      title: 'Locuta - US East',
    },
    {
      id: 90,
      title: 'Loloi - US East',
    },
    {
      id: 91,
      title: 'Lukomorye - US East',
    },
    {
      id: 92,
      title: 'Maca - US East',
    },
    {
      id: 93,
      title: 'Macaria - US East',
    },
    {
      id: 174,
      title: 'Mag Mell - US West',
    },
    {
      id: 94,
      title: 'Maharloka - US East',
    },
    {
      id: 95,
      title: 'Maldonada - US East',
    },
    {
      id: 96,
      title: 'Maleas - US East',
    },
    {
      id: 175,
      title: 'Manghalour - US West',
    },
    {
      id: 97,
      title: 'Maramma - US East',
    },
    {
      id: 98,
      title: 'Metnal - US East',
    },
    {
      id: 99,
      title: 'Mictlan - US East',
    },
    {
      id: 176,
      title: 'Midian - US West',
    },
    {
      id: 177,
      title: 'Mimisbrunnr - US West',
    },
    {
      id: 100,
      title: 'Minda - US East',
    },
    {
      id: 101,
      title: 'Moriai - US East',
    },
    {
      id: 102,
      title: 'Morrow - US East',
    },
    {
      id: 103,
      title: 'Mu - US East',
    },
    {
      id: 178,
      title: 'Mulitefao - US West',
    },
    {
      id: 179,
      title: 'Neno Kuni - US West',
    },
    {
      id: 104,
      title: 'Nepenthe - US East',
    },
    {
      id: 105,
      title: 'Neritum - US East',
    },
    {
      id: 180,
      title: 'Nidavellir - US West',
    },
    {
      id: 106,
      title: 'Nolandia - US East',
    },
    {
      id: 107,
      title: 'Norumbega - US East',
    },
    {
      id: 108,
      title: 'Nunne Chaha - US East',
    },
    {
      id: 109,
      title: 'Oceana - US East',
    },
    {
      id: 110,
      title: 'Ogygia - US East',
    },
    {
      id: 111,
      title: 'Ohonoo - US East',
    },
    {
      id: 112,
      title: 'Olympus - US East',
    },
    {
      id: 113,
      title: 'Omeyocan - US East',
    },
    {
      id: 114,
      title: 'Onkeion - US East',
    },
    {
      id: 115,
      title: 'Onogoro - US East',
    },
    {
      id: 181,
      title: 'Ophir - US West',
    },
    {
      id: 116,
      title: 'Opona - US East',
    },
    {
      id: 117,
      title: 'Oponskoye - US East',
    },
    {
      id: 118,
      title: 'Orofena - US East',
    },
    {
      id: 182,
      title: 'Ortygia - US West',
    },
    {
      id: 119,
      title: 'Orun - US East',
    },
    {
      id: 120,
      title: 'Pahruli - US East',
    },
    {
      id: 209,
      title: 'Pangea - US East',
    },
    {
      id: 183,
      title: 'Parima - US West',
    },
    {
      id: 184,
      title: 'Phlegethon - US West',
    },
    {
      id: 185,
      title: 'Plancta - US West',
    },
    {
      id: 221,
      title: 'Pleiades - US West',
    },
    {
      id: 121,
      title: 'Pleroma - US East',
    },
    {
      id: 122,
      title: 'Pluto - US East',
    },
    {
      id: 123,
      title: 'Podesta - US East',
    },
    {
      id: 186,
      title: 'Pohjola - US West',
    },
    {
      id: 187,
      title: 'Ptolemais - US West',
    },
    {
      id: 124,
      title: 'Pyrallis - US East',
    },
    {
      id: 188,
      title: 'Quanlu - US West',
    },
    {
      id: 189,
      title: 'Rarohenga - US West',
    },
    {
      id: 190,
      title: 'Riallaro - US West',
    },
    {
      id: 191,
      title: 'Rivadeneyra - US West',
    },
    {
      id: 208,
      title: 'Rosa - US East',
    },
    {
      id: 125,
      title: 'Rosetau - US East',
    },
    {
      id: 126,
      title: 'Royllo - US East',
    },
    {
      id: 127,
      title: 'Ruach - US East',
    },
    {
      id: 192,
      title: 'Rupes Nigra - US West',
    },
    {
      id: 193,
      title: 'Saknussemm - US West',
    },
    {
      id: 194,
      title: 'Samavasarana - US West',
    },
    {
      id: 195,
      title: 'Sannikov Land - US West',
    },
    {
      id: 128,
      title: 'Santu - US East',
    },
    {
      id: 196,
      title: 'Sarragalla - US West',
    },
    {
      id: 197,
      title: 'Satanazes - US West',
    },
    {
      id: 129,
      title: 'Savoya - US East',
    },
    {
      id: 130,
      title: 'Scheria - US East',
    },
    {
      id: 131,
      title: 'Silha - US East',
    },
    {
      id: 132,
      title: 'Sitara - US East',
    },
    {
      id: 217,
      title: 'Sundew - US East',
    },
    {
      id: 198,
      title: 'Taenarum - US West',
    },
    {
      id: 133,
      title: 'Takamagahara - US East',
    },
    {
      id: 134,
      title: 'Tamoanchan - US East',
    },
    {
      id: 199,
      title: 'Tarshish - US West',
    },
    {
      id: 200,
      title: 'Tayopa - US West',
    },
    {
      id: 201,
      title: 'Theleme - US West',
    },
    {
      id: 135,
      title: 'Themiscyra - US East',
    },
    {
      id: 202,
      title: 'Tipra Chonnlai - US West',
    },
    {
      id: 136,
      title: 'Tlalocan - US East',
    },
    {
      id: 203,
      title: 'Tlillan-Tlapallan - US West',
    },
    {
      id: 137,
      title: 'Topan - US East',
    },
    {
      id: 138,
      title: 'Trapalanda - US East',
    },
    {
      id: 139,
      title: 'Tritonis - US East',
    },
    {
      id: 140,
      title: 'Tulgey Wood - US East',
    },
    {
      id: 141,
      title: 'Tumtum - US East',
    },
    {
      id: 204,
      title: 'Tuonela - US West',
    },
    {
      id: 205,
      title: 'Uku Pacha - US West',
    },
    {
      id: 142,
      title: 'Ute-Yomigo - US East',
    },
    {
      id: 143,
      title: 'Utensia - US East',
    },
    {
      id: 144,
      title: 'Vaitarani - US East',
    },
    {
      id: 145,
      title: 'Valgrind - US East',
    },
    {
      id: 146,
      title: 'Valhalla - US East',
    },
    {
      id: 147,
      title: 'Vidblain - US East',
    },
    {
      id: 148,
      title: 'Vingolf - US East',
    },
    {
      id: 149,
      title: 'Vlaanderen - US East',
    },
    {
      id: 206,
      title: 'Vourukasha - US West',
    },
    {
      id: 150,
      title: 'Vyraj - US East',
    },
    {
      id: 151,
      title: 'Xibalba - US East',
    },
    {
      id: 152,
      title: 'Yaxche - US East',
    },
    {
      id: 153,
      title: 'Ydalir - US East',
    },
    {
      id: 207,
      title: 'Yggdrasil - US West',
    },
    {
      id: 154,
      title: 'Yinfu - US East',
    },
    {
      id: 155,
      title: 'Youming - US East',
    },
    {
      id: 156,
      title: 'Ys - US East',
    },
    {
      id: 157,
      title: 'Zugen - US East',
    },
    {
      id: 158,
      title: 'Zuvendis - US East',
    },
  ],
  // Не забудь обновить бэк.
  // @see \App\Types\Maps\ServerMap -> ProductGameEnum::GAME_NW -> ServerMap::NW_REGION_SOUTH_AMERICA
  [NewWorldRegionModel.SOUTH_AMERICA.id]: [
    {
      id: 1,
      title: 'Alatyr - SA East',
    },
    {
      id: 2,
      title: 'Albur - SA East',
    },
    {
      id: 36,
      title: 'Alkaid - SA East',
    },
    {
      id: 3,
      title: 'Anu - SA East',
    },
    {
      id: 4,
      title: 'Apsu - SA East',
    },
    {
      id: 5,
      title: 'Arali - SA East',
    },
    {
      id: 6,
      title: 'Aratta - SA East',
    },
    {
      id: 36,
      title: 'Artorius - SA East',
    },
    {
      id: 7,
      title: 'Atlantis - SA East',
    },
    {
      id: 8,
      title: 'Bhuloka - SA East',
    },
    {
      id: 39,
      title: 'Chertan - SA East',
    },
    {
      id: 37,
      title: 'Cursa - SA East',
    },
    {
      id: 9,
      title: 'Devaloka - SA East',
    },
    {
      id: 10,
      title: 'Dilmun - SA East',
    },
    {
      id: 11,
      title: 'Dunnu - SA East',
    },
    {
      id: 12,
      title: 'Ekur - SA East',
    },
    {
      id: 13,
      title: 'Eugea - SA East',
    },
    {
      id: 14,
      title: 'Hubur - SA East',
    },
    {
      id: 15,
      title: 'Irkalla (ES/EN) - SA East',
    },
    {
      id: 16,
      title: 'Jianmu - SA East',
    },
    {
      id: 17,
      title: 'Kasanaan - SA East',
    },
    {
      id: 18,
      title: 'Kigal - SA East',
    },
    {
      id: 19,
      title: 'Kitezh - SA East',
    },
    {
      id: 20,
      title: 'Kukku - SA East',
    },
    {
      id: 21,
      title: 'Kunlun - SA East',
    },
    {
      id: 22,
      title: 'Lanka - SA East',
    },
    {
      id: 23,
      title: 'Liusha - SA East',
    },
    {
      id: 24,
      title: 'Modun - SA East',
    },
    {
      id: 25,
      title: 'Morven - SA East',
    },
    {
      id: 26,
      title: 'Nammu - SA East',
    },
    {
      id: 27,
      title: 'Naraka - SA East',
    },
    {
      id: 38,
      title: 'Nihal - SA East',
    },
    {
      id: 28,
      title: 'Niraya - SA East',
    },
    {
      id: 29,
      title: 'Patala - SA East',
    },
    {
      id: 30,
      title: 'Rukh - SA East',
    },
    {
      id: 31,
      title: 'Sanzu - SA East',
    },
    {
      id: 32,
      title: 'Svarga - SA East',
    },
    {
      id: 33,
      title: 'Tamag - SA East',
    },
    {
      id: 34,
      title: 'Taparloka - SA East',
    },
    {
      id: 35,
      title: 'Tuma - SA East',
    },
  ],
};

export { NewWorldRegionModel, NewWorldServerModel };
